import React from "react";
import "./styles.css";

export default ({ children }) => <div className="tag">{children}</div>;
